$(document).ready(function() {
  bl_custom_tab_code();  
});
function bl_custom_tab_code(){
  var original_title = document.title;
  var message = "Save your back!";
  var typewriting_counter = 1;
  var typewriting_timer;
  var originalFaviconHref = $("#favicon").attr("href");
  var altFavIcon = "//www.deskbird.co.nz/cdn/shop/files/Screenshot_2023-07-29_at_10.40.06_PM.png?v=1690627221&width=32";

  function createWorker(main) {
    var blob = new Blob(
      ["(" + main.toString() + ")(self)"],
      {type: "text/javascript"}
    );
    return new Worker(window.URL.createObjectURL(blob));
  }

  var worker = createWorker(function(self){
    setInterval(function(){
      self.postMessage(Date.now());
    }, (300));
  });

  worker.onmessage = function(e) {
    if(!document.hasFocus()){
      document.title = message.substr(0, typewriting_counter);
      $("#favicon").attr("href", altFavIcon);

      if (typewriting_counter == message.length) {
        typewriting_counter = 1;
      } else {
        typewriting_counter++;
      }
    } else {
      $("#favicon").attr("href", originalFaviconHref);
      typewriting_counter = 1;
    }
  }
  
  $(window).focus(function() {
    document.title = original_title;
  });
}  

jQuery_T4NT(document).ready(function($) {
  
    $( document ).on( "variant:changed", function( evt ) {
      var variant = evt.currentVariant;
      var $priceWrapper = $('.bl-cus__product-price-save-amount_wrapper');
      var $saveAmountWrapper = $('.bl-product-price__save-amount');
      var $saveAmount = $('#bl-product-price-save-amount');
      
      if (variant.compare_at_price != null && variant.compare_at_price > variant.price) {
        if (!$priceWrapper.hasClass('onsale')) {
          $priceWrapper.addClass('onsale');
        }
        // Calculate the savings
        var saveAmount = variant.compare_at_price - variant.price;
        var formattedSaveAmount = (saveAmount / 100).toFixed(2);
        
        $saveAmount.html('$' + formattedSaveAmount);
        
        $saveAmountWrapper.show();
      } else {
        if ($priceWrapper.hasClass('onsale')) {
          $priceWrapper.removeClass('onsale');
        }
        $saveAmountWrapper.hide();
      }
    });
  
});